import { Suspense, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core'
import { MasterInit } from '../_metronic/layout/MasterInit'
import { QueryClientProvider } from 'react-query'
import { queryClient } from '../queries/client'
import GlobalContextProvider from './pages/store/context/globalContext'
import { getUserId, getUserPreferences } from '../utils/SessionStorageUtils'
import { amplitudeInit } from '../utils/amplitude'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import 'ag-grid-community/styles/ag-theme-material.css'
import * as AgGrid from 'ag-grid-enterprise'
import { Modal } from 'react-bootstrap'
import { getAuthStore } from '../store/useAuthStore'

const App = () => {
  amplitudeInit()
  let userId = getUserId()
  let userPreferencesObj = userId ? getUserPreferences(userId) : undefined
  let ctxGroupIds: number[] = []
  let ctxInvestorIds: number[] = []
  let ctxUserId = 0
  let userCurrency = ''
  let filterType: 'Fund' | 'Group' | 'All' = 'Fund'
  let includeExits = true
  let showExits = false
  if (userPreferencesObj && userId) {
    ctxUserId = userId
    userCurrency = userPreferencesObj.userCurrency!
    ctxGroupIds = userPreferencesObj.selectedGroups
    ctxInvestorIds = userPreferencesObj.selectedInvestors
    filterType =
      userPreferencesObj.filterType === 'Fund'
        ? 'Fund'
        : userPreferencesObj.filterType === 'Group'
        ? 'Group'
        : 'All'
  }
  const agGridLicenseKey = process.env.REACT_APP_AG_LICENSE_KEY || ''
  AgGrid.LicenseManager.setLicenseKey(agGridLicenseKey)

  const isIframe = window.self !== window.top

  const [isAllowed, setIsAllowed] = useState<boolean>(isIframe || true)

  useEffect(() => {
    if (isIframe) return undefined // Skip instance check if running inside an iframe

    const instanceKey = 'reactAppInstance'
    const channel = new BroadcastChannel(instanceKey)

    channel.onmessage = (event) => {
      if (event.data === 'CHECK_INSTANCE') {
        channel.postMessage('INSTANCE_ACTIVE')
      } else if (event.data === 'INSTANCE_ACTIVE') {
        setIsAllowed(false)
      }
    }

    channel.postMessage('CHECK_INSTANCE')

    return () => {
      sessionStorage.clear()
      getAuthStore().clearAuthorization()
      channel.close()
    }
  }, [])

  return (
    <>
      {!isAllowed && (
        <Modal
          id='kt_modal_add_inv'
          tabIndex={-1}
          dialogClassName='modal-dialog modal-dialog-centered mw-400px '
          show={!isAllowed}
        >
          <Modal.Title className='text-danger fw-bold p-6 pb-3'>Warning!!!</Modal.Title>
          <div className='separator'></div>
          <Modal.Body>
            You have already logged into this Platform on another browser tab. Kindly revert to the
            original login tab or close the other tab to proceed.
          </Modal.Body>
        </Modal>
      )}
      {isAllowed && (
        <QueryClientProvider client={queryClient}>
          <GlobalContextProvider
            ctxUserId={ctxUserId}
            ctxGroupIds={ctxGroupIds}
            ctxInvestorIds={ctxInvestorIds}
            filterType={filterType}
            includeExits={includeExits}
            showExits={showExits}
            userCurrency={userCurrency}
          >
            <Suspense fallback={<LayoutSplashScreen />}>
              <I18nProvider>
                <LayoutProvider>
                  <Outlet />
                  <MasterInit />
                </LayoutProvider>
              </I18nProvider>
            </Suspense>
          </GlobalContextProvider>
        </QueryClientProvider>
      )}
    </>
  )
}

export { App }
